<script setup>
import { ref, computed, onMounted } from 'vue';
import LineBarChart from '@/components/LineBarChart.vue';
import MStateBox from '@/rebuild/components/MStateBox.vue';
import ComparisonSelections from './ComparisonSelections.vue';
import { useMainBusinessData } from './useMainBusinessData';

const props = defineProps({
	item: {
		type: Object,
		required: true
	},

	isOverview: {
		type: Boolean,
		default: false
	}
});

const { loadData, getDataFunc } = useMainBusinessData();
const activeScale = ref(2);
const activeDate = ref(5);
const activePeriod = ref('A');

const wrapLoading = ref(false);
const resData = ref([]);
const getChatOriginData = computed(() => (resData.value || []).sort((a, b) => a.reportDate - b.reportDate));
const wrapEmpty = computed(() => getChatOriginData.value.length === 0 && !wrapLoading.value);

async function refresh() {
	wrapLoading.value = true;
	const res = await loadData({
		classifCd: props.item.classifCd,
		reportType: activePeriod.value
	});
	resData.value = res;
	console.log('🚀 ~ refresh ~ resData:', resData);
	initData();
	wrapLoading.value = false;
}
onMounted(() => {
	refresh();
});

const chartData = ref({ seriesData: [] });
const tableData = ref([]);
const dynamicColumns = ref([]);

function initData() {
	console.log(getChatOriginData.value, resData.value, activeDate.value, activePeriod.value);
	const { chartOptions, tableOptions } = getDataFunc({
		list: resData.value,
		type: activeScale.value,
		timeType: activeDate.value,
		period: activePeriod.value
	});
	chartData.value = chartOptions || { seriesData: [] };
	console.log('🚀 ~ initData ~ chartData.value :', chartData.value);
	tableData.value = tableOptions.data || [];
	dynamicColumns.value = tableOptions.columns || [];
}
</script>

<template>
	<div class="main-business-data">
		<div v-if="!isOverview" class="tabs-selects">
			<div class="block">
				<p class="title">{{ props.item.name }}</p>
			</div>
			<ComparisonSelections
				:activeDate.sync="activeDate"
				:activePeriod.sync="activePeriod"
				:activeScale.sync="activeScale"
				@scaleChange="initData"
				@dateChange="initData"
				@periodChange="refresh"
			/>
		</div>
		<div class="chart-wrapper">
			<MStateBox :loading="wrapLoading" :empty="wrapEmpty" class="chart-wrapper-box">
				<LineBarChart v-bind="chartData" class="chart-wrapper-box-chart" />
				<!-- <el-table :data="tableData" class="el-table--v-slide chart-wrapper-box-table">
					<el-table-column prop="name" min-width="150" show-overflow-tooltip fixed="left"></el-table-column>
					<el-table-column
						v-for="item in dynamicColumns"
						:label="item"
						:key="item"
						:prop="item"
						min-width="120"
					></el-table-column>
				</el-table> -->
			</MStateBox>
		</div>
	</div>
</template>

<style lang="less">
.main-business-data {
	min-height: 120px;
	.tabs-selects {
		display: flex;
		align-items: center;
		justify-content: space-between;
		.title {
			color: var(--emphasis-color);

			font-size: 16px;

			font-weight: 600;
			line-height: 24px;
		}

		.compare-selections {
			display: flex;
			align-items: center;

			.compare-item {
				width: 88px;

				& + .compare-item {
					margin-left: 16px;
				}

				.el-input {
					.el-input__suffix {
						right: 7.5px;
					}
					.el-select__caret {
						display: flex;
						align-items: center;
						justify-content: center;

						color: var(--secondary-color);
					}
				}
			}
		}
		.common-tab {
			width: 580px;
		}
	}
	.chart-wrapper {
		width: 100%;
		// height: 256px;

		.chart-wrapper-box {
			height: 100%;
			&-chart {
				height: 256px;
			}
			&-table {
				margin-top: 20px;
			}
		}
	}
	.tabs-selects + .chart-wrapper {
		margin-top: 16px;
	}
}
.compare-select-popover {
	width: 88px;

	.el-select-dropdown__item {
		padding: 0 12px !important;
	}
	.popper__arrow {
		display: none;
	}
}
</style>
